
import DeviceSelector from "../pages/components/DeviceSelector"
import socket from '../socket.js'
import {useState,useEffect} from 'react'

function DashboardHeader() {

    return (

        <div className="
            h-20
            bg-slate-900
            border-b
            border-slate-800
            flex
            items-center
            justify-between
            px-8
        ">
        <div className="text-left">

          <DeviceSelector/>

        </div>
            <div>

                <h1 className="text-2xl font-bold text-white">

                    داشبورد

                </h1>

                <p className="text-gray-400 text-sm">

                    پنل مدیریت

                </p>

            </div>

<div>
</div>

        </div>

    );

}

export default DashboardHeader;
